import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function SuccessIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 163 163'
    >
      <rect
        y='0.5'
        width='163'
        height='163'
        rx='81.5'
        fill='#ECFDD8'
      />
      <g clipPath='url(#clip0_174_6915)'>
        <path
          d='M81.5 42C73.5888 42 65.8552 44.346 59.2772 48.7412C52.6992 53.1365 47.5723 59.3836 44.5448 66.6927C41.5173 74.0017 40.7252 82.0444 42.2686 89.8036C43.812 97.5629 47.6216 104.69 53.2157 110.284C58.8098 115.878 65.9372 119.688 73.6964 121.231C81.4556 122.775 89.4983 121.983 96.8074 118.955C104.116 115.928 110.364 110.801 114.759 104.223C119.154 97.6448 121.5 89.9113 121.5 82C121.5 76.7471 120.465 71.5457 118.455 66.6927C116.445 61.8396 113.499 57.4301 109.784 53.7157C106.07 50.0014 101.66 47.055 96.8074 45.0448C91.9543 43.0346 86.7529 42 81.5 42ZM81.5 114C75.171 114 68.9841 112.123 63.7218 108.607C58.4594 105.091 54.3579 100.093 51.9359 94.2459C49.5139 88.3986 48.8802 81.9645 50.1149 75.7571C51.3496 69.5497 54.3973 63.8479 58.8726 59.3726C63.3479 54.8973 69.0497 51.8496 75.2571 50.6149C81.4645 49.3801 87.8987 50.0139 93.7459 52.4359C99.5931 54.8579 104.591 58.9594 108.107 64.2218C111.623 69.4841 113.5 75.671 113.5 82C113.5 90.4869 110.129 98.6263 104.127 104.627C98.1263 110.629 89.9869 114 81.5 114Z'
          fill='#66D83C'
        />
        <path
          d='M92.2998 67.5597L77.1798 87.5597L70.6598 79.1197C70.0073 78.2816 69.0487 77.7371 67.9948 77.6058C66.9408 77.4745 65.8779 77.7673 65.0398 78.4197C64.2017 79.0722 63.6571 80.0308 63.5258 81.0848C63.3946 82.1387 63.6873 83.2016 64.3398 84.0397L74.0598 96.4797C74.4365 96.9564 74.9168 97.3411 75.4643 97.6045C76.0119 97.8678 76.6122 98.003 77.2198 97.9997C77.8307 97.9983 78.4331 97.8569 78.9808 97.5865C79.5286 97.3161 80.0072 96.9238 80.3798 96.4397L98.6598 72.4397C99.3069 71.591 99.5904 70.52 99.4479 69.4623C99.3053 68.4046 98.7485 67.4469 97.8998 66.7997C97.0511 66.1526 95.9801 65.8691 94.9224 66.0116C93.8647 66.1542 92.9069 66.711 92.2598 67.5597H92.2998Z'
          fill='#66D83C'
        />
      </g>
      <defs>
        <clipPath id='clip0_174_6915'>
          <rect
            width='96'
            height='96'
            fill='white'
            transform='translate(33.5 34)'
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
